import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface BrevoContact {
  id: number;
  email: string;
  emailBlacklisted: boolean;
  smsBlacklisted: boolean;
  createdAt: string;
  updatedAt: string;
  attributes: Record<string, unknown>;
  listIds: number[];
}

export function useBrevoContacts(limit = 50, offset = 0) {
  return useQuery({
    queryKey: ['brevo-contacts', limit, offset],
    queryFn: () => apiClient<{ contacts: BrevoContact[]; total: number }>(`/brevo/contacts?limit=${limit}&offset=${offset}`),
  });
}
